import { SVG } from '@sleepstation/components'
import { fill } from '@sleepstation/style-api-helpers'
import { SleepstationMarkSvg } from '@sleepstation/svgs-sleepstation-branding'
import { rem } from '@sleepstation/utils'
import PropTypes from 'prop-types'
import { map } from 'ramda'
import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const LOGO_WIDTHS = map(rem, [113, 185])

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(Link).attrs({ 'data-cy': `header-logo-link` })`
  display: flex;
  justify-content: stretch;
  align-items: stretch;

  path {
    ${fill(`body`)}
  }
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const LogoLink = ({ to, logoSvg }) => (
  <Layout to={to}>
    <SVG svg={logoSvg} widths={LOGO_WIDTHS} />
  </Layout>
)

LogoLink.propTypes = {
  to: PropTypes.string,
  logoSvg: PropTypes.func,
}

LogoLink.defaultProps = {
  logoSvg: SleepstationMarkSvg,
  to: `/`,
}

export default LogoLink
